
<template>
  <v-application>
    <v-settings :loading_data="loading_workgroup_commnets">
      <v-toolbar flat class="pt-2">
        <v-toolbar-title>{{ $t("workgroup_comments") }}</v-toolbar-title>
        <v-spacer />
        <v-btn v-if="disabled" @click="disabled = false" icon>
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form v-model="is_valid">
        <v-card-text>
          <v-list>
            <v-list-item
              :disabled="disabled"
              v-for="(item, index) in workgroup_comments"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-layout row px-2>
                  <v-flex md6 px-2>
                    <v-text-field
                      hide-details
                      outlined
                      dense
                      v-model="workgroup_comments[index].text"
                      :rules="[fieldRules.required]"
                      :label="$t('text')"
                    />
                  </v-flex>
                  <v-flex md6 px-2>
                    <v-autocomplete
                      hide-details
                      outlined
                      dense
                      multiple
                      :items="workgroups"
                      item-value="_id"
                      item-text="name"
                      :label="$t('workgroups')"
                      v-model="workgroup_comments[index].workgroups"
                    />
                  </v-flex>
                </v-layout>
              </v-list-item-content>
              <v-list-item-icon v-if="!disabled">
                <v-btn icon @click="remove_ticket(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
          <v-btn
            v-if="!disabled"
            :disabled="loading_workgroup_commnets"
            text
            color="primary"
            small
            v-on:click="workgroup_comments.push({workgroups: []})"
          >
            <v-icon>mdi-plus</v-icon>
            {{ $t("add_workgroup_comment") }}
          </v-btn>
        </v-card-text>
      </v-form>
      <template v-slot:actions>
        <v-btn
          v-if="!disabled"
          :disabled="loading_workgroup_commnets"
          text
          v-on:click="cancelClicked"
          >{{$t('cancel')}}</v-btn
        >
        <v-btn
          v-if="!disabled"
          :disabled="loading_workgroup_commnets || !is_valid"
          text
          color="primary"
          v-on:click="saveClicked"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>
  </v-application>
</template>

<script>
import WorkgroupComments from "../../mixins/employees/workgroup_comments";
import Workgroups from "../../mixins/employees/workgroup";

export default {
  name: "WorkgroupComment",
  data: () => ({
    disabled: true,
    loading_workgroup_commnets: false,
    is_valid: false,
  }),
  mixins: [Workgroups, WorkgroupComments],
  methods: {
    async cancelClicked() {
      this.loading_workgroup_commnets = true;
      await this.workgroup_comments_get_own();
      this.loading_workgroup_commnets = false;
      this.disabled = true;
    },
    remove_ticket(index) {
      this.workgroup_comments.splice(index, 1);
    },
    async saveClicked() {
      this.loading_workgroup_commnets = true;
      await this.workgroup_comments_create();
      this.loading_workgroup_commnets = false;
      this.disabled = true;
      this.cancelClicked();
    },
  },
  mounted() {
    this.cancelClicked();
    this.get_workgroup();
  },
};
</script>
